import {openModal} from "../functions/openModal";

;(function (document, window) {
    $(document).on('submit', '.js-ajax-send-form', function (event) {
        event.preventDefault();
        let $this = $(this);
        let $messageBlock = $this.find('.js-message-block');
        $messageBlock.empty().removeClass('has-error').removeClass('has-success');
        $.ajax({
            type: $this.attr('method'),
            url: $this.attr('action'),
            data: $this.serialize(),
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    $messageBlock.addClass('has-success').text(response.message);
                    $this.trigger('reset');
                    openModal('.modal#success')
                } else {
                    $messageBlock.addClass('has-error').text(response.message);
                }
            },
            error: function (response) {
                $messageBlock.addClass('error');
                if (response.status === 422) {
                    let errors = '';
                    for (let key in response.responseJSON.errors) {
                        if (response.responseJSON.errors.hasOwnProperty(key)) {
                            errors += response.responseJSON.errors[key].map(error => `<p>${error}</p>`).join('')
                        }
                    }
                    $messageBlock.addClass('has-error').html(errors);
                } else if (response.status === 403) {
                    $messageBlock.addClass('has-error').html('Необходимо авторизоваться');
                } else {
                    $messageBlock.addClass('has-error').html(response.statusText);
                }
            },
        })
    })
})(document, window);
